module.exports = __webpack_public_path__ + "static/media/SDG9.eee9c955.mp4";